import { useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { MessageContext } from '@/helpers/MessageProvider';

const useRemoteDebugCommand = () => {
  const { publishCommand } = useContext(MessageContext);

  const aircraftCharge = (isOpen) => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();
    const dockSerialNumber = robot.metadata['DJI_DOCK_SN'];
    const method = isOpen ? 'charge_open' : 'charge_close';

    const execute = () => {
      return publishCommand(robot, 'remote_debug/aircraft/charge', [tid, bid, Date.now(), dockSerialNumber, method]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/${method}`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  const aircraftPower = (isOpen) => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();
    const dockSerialNumber = robot.metadata['DJI_DOCK_SN'];
    const method = isOpen ? 'drone_open' : 'drone_close';

    const execute = () => {
      return publishCommand(robot, 'remote_debug/aircraft/power', [tid, bid, Date.now(), dockSerialNumber, method]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/${method}`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  const debugMode = (isOpen) => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();
    const dockSerialNumber = robot.metadata['DJI_DOCK_SN'];
    const method = isOpen ? 'debug_mode_open' : 'debug_mode_close';

    const execute = () => {
      return publishCommand(robot, 'remote_debug/mode', [tid, bid, Date.now(), dockSerialNumber, method]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/${method}`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  const dockCanopy = (isOpen) => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();
    const dockSerialNumber = robot.metadata['DJI_DOCK_SN'];
    const method = isOpen ? 'cover_open' : 'cover_close';

    const execute = () => {
      return publishCommand(robot, 'remote_debug/dock/canopy', [tid, bid, Date.now(), dockSerialNumber, method]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/${method}`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  const dockRestart = () => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();
    const dockSerialNumber = robot.metadata['DJI_DOCK_SN'];

    const execute = () => {
      return publishCommand(robot, 'remote_debug/dock/restart', [tid, bid, Date.now(), dockSerialNumber]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/device_reboot`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  return {
    aircraftCharge,
    aircraftPower,
    debugMode,
    dockCanopy,
    dockRestart,
  };
};

export default useRemoteDebugCommand;
